<script>
import BasePrintArtwork from '@/components/Modal/BasePrintArtwork.vue'
import Status from './Status.vue'

export default {
  extends: BasePrintArtwork,
  components: {
    Status
  }
}
</script>
